import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/role-supports-aria-props */
import classNames from 'classnames';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import { usePseudoClasses } from '@helsenorge/designsystem-react/hooks/usePseudoClasses';
import { palette } from '@helsenorge/designsystem-react/theme/palette';
import { getIcon } from './utils';
import styles from './styles.module.scss';
const ScoreInput = ({ label, value, disabled, selected, expanded, onChange, ref, ...rest }) => {
    const { refObject: hoverRef, isHovered } = usePseudoClasses();
    const id = `feedback-score-${value}`;
    return (_jsxs("label", { htmlFor: id, className: classNames(styles.scoreinput, selected && styles['scoreinput--selected']), ref: hoverRef, children: [_jsx("input", { type: "radio", value: value, disabled: disabled, "aria-expanded": expanded, className: styles.scoreinput__radio, id: id, ref: ref, onChange: onChange, ...rest }), _jsx(Icon, { svgIcon: getIcon(value), color: selected ? palette.white : palette.plum700, isHovered: isHovered }), _jsx("span", { className: styles.scoreinput__text, children: label })] }));
};
export default ScoreInput;
